var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPower = function SvgIconPower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 4.5a1 1 0 1 0-2 0v7.125a1 1 0 1 0 2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.045 5.92a1 1 0 0 0-1.09-1.677 9.25 9.25 0 1 0 10.09 0 1 1 0 0 0-1.09 1.676 7.25 7.25 0 1 1-7.91 0"
  }))));
};
export default SvgIconPower;